import React from 'react';
import { useIntl } from 'react-intl';
import { Chip, CircularProgress } from '@mui/material';
import { isActiveStatus } from '../constants';
import { statusLabel } from '../remoteCommandsUtils';

const STATUS_COLORS = {
	SUCCEEDED: 'success',
	FAILED: 'error',
	REJECTED: 'error',
	TIMED_OUT: 'warning',
};

/** Translated status; active statuses ("In progress") carry a spinner. */
export const RemoteCommandStatusChip = ({ status }) => {
	const { messages } = useIntl();
	let icon;
	if (isActiveStatus(status)) icon = <CircularProgress size={12} aria-hidden="true" />;

	return (
		<Chip
			size="small"
			variant="outlined"
			icon={icon}
			color={STATUS_COLORS[status] || 'default'}
			label={statusLabel(status, messages)}
			className="oem-remote-status"
		/>
	);
};
